import React, { useState } from "react";
import AnnouncementsManager from "./AnnouncementsManager"; // Duyuruları yöneten bileşen
import ContentManager from "./ContentManager"; // Başlık ve içerik yöneten bileşen
import ManagementManager from "./ManagementManager";
import SlideManager from "./SlideManager";
import "./AdminPanel.css";

function AdminPanel() {
  const [activeTab, setActiveTab] = useState("announcements"); // Hangi sekmenin açık olduğunu takip eder

  return (
    <div className="admin-panel">
      <h1>Admin Panel</h1>
      <div className="tabs">
        <button onClick={() => setActiveTab("announcements")}>Duyurular</button>
        <button onClick={() => setActiveTab("content")}>Başlık ve İçerik Yönetimi</button>
        <button onClick={() => setActiveTab("yonetim")}>Yönetim Başlığı</button>
        <button onClick={() => setActiveTab("slayt")}>Slayt Gösterileri</button>
      </div>

      <div className="tab-content">
        {activeTab === "announcements" && <AnnouncementsManager />}
        {activeTab === "content" && <ContentManager />}
        {activeTab === "yonetim" && <ManagementManager />}
        {activeTab === "slayt" && <SlideManager />} 
      </div>
    </div>
  );
}

export default AdminPanel;
